var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 .75C0 .335786.335786 0 .75 0H9c.41421 0 .75.335786.75.75 0 .41421-.33579.75-.75.75H1.5v12H4c.25076 0 .48494.1253.62404.334L6 15.8979l1.37596-2.0639c.1391-.2087.37328-.334.62404-.334h8.5V8.68182c0-.41422.3358-.75.75-.75s.75.33578.75.75V14.25c0 .4142-.3358.75-.75.75H8.40139l-1.77735 2.666C6.48494 17.8747 6.25076 18 6 18c-.25076 0-.48494-.1253-.62404-.334L3.59861 15H.75c-.414214 0-.75-.3358-.75-.75V.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8697.219661c.2929-.292893.7678-.292893 1.0607 0l2.8284 2.828429c.1406.14065.2197.33142.2197.53033 0 .19891-.0791.38968-.2197.53033l-6.1924 6.19235c-.1407.1407-.3314.2197-.5303.2197H8.20764c-.19892 0-.38968-.079-.53033-.2197-.14066-.1406-.21967-.33138-.21967-.53029V6.94238c0-.19891.07901-.38968.21967-.53033L13.8697.219661ZM14.4 1.81065 8.95764 7.25304v1.76777h1.76776l5.4424-5.44239L14.4 1.81065Z",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatPencil);
export default __webpack_public_path__ + "static/media/chat-pencil.baf8f0ce567f4857c48a8a9ede153661.svg";
export { ForwardRef as ReactComponent };